import React, { useEffect, useState } from "react"

export default function ViewTransition({ isActive, transitionStage }) {
  const [aureoles, setAureoles] = useState([])

  useEffect(() => {
    if (isActive) {
      const newAureoles = []
      const aureoleTypes = ["AurFos", "AurGre", "AurRed", "AurWh", "AurYell"]

      aureoleTypes.forEach((type) => {
        for (let i = 0; i < 5; i++) {
          newAureoles.push({
            id: `${type}-${i}`,
            type,
            x: Math.random() * window.innerWidth,
            y: Math.random() * window.innerHeight,
            scale: Math.random() * 0.5 + 0.5,
            rotation: Math.random() * 360,
            speed: Math.random() * 2 + 1,
          })
        }
      })

      setAureoles(newAureoles)
    } else {
      setAureoles([])
    }
  }, [isActive])

  return (
    <div
      className={`fixed inset-0 z-40 pointer-events-none ${
        isActive ? "opacity-100" : "opacity-0"
      } ${transitionStage}`}
      style={{
        background: "rgb(0, 0, 0)",
      }}
    >
      {aureoles.map((aureole) => (
        <div
          key={aureole.id}
          className="absolute transition-all duration-[2000ms] ease-in-out aureole"
          style={{
            left: `${aureole.x}px`,
            top: `${aureole.y}px`,
            transform: `translate(-50%, -50%) scale(${aureole.scale}) rotate(${aureole.rotation}deg)`,
            opacity: transitionStage === "fadeIn" ? 1 : 0,
            animationDelay: `${Math.random() * 5}s`,
          }}
        >
          <img
            src={`/images/${aureole.type}.png`}
            alt=""
            className="w-32 h-32 object-contain mix-blend-screen"
          />
        </div>
      ))}
      <style jsx>{`
        @font-face {
          font-family: "Delogy";
          src: url("/fonts/Delogy-Regular.ttf") format("truetype");
          font-weight: normal;
          font-style: normal;
        }
        @keyframes float {
          0% {
            transform: translate(0, 0) scale(1) rotate(0deg);
          }
          33% {
            transform: translate(
                ${Math.random() * 100 - 50}px,
                ${Math.random() * 100 - 50}px
              )
              scale(${Math.random() * 0.4 + 0.8})
              rotate(${Math.random() * 60 - 30}deg);
          }
          66% {
            transform: translate(
                ${Math.random() * 100 - 50}px,
                ${Math.random() * 100 - 50}px
              )
              scale(${Math.random() * 0.4 + 0.8})
              rotate(${Math.random() * 60 - 30}deg);
          }
          100% {
            transform: translate(0, 0) scale(1) rotate(0deg);
          }
        }
        .aureole {
          animation: float 10s infinite ease-in-out;
        }
      `}</style>
    </div>
  )
}
